const observerOptions = {
    root: null,
    threshold: 0,
    rootMargin: '-10px'
};

const observer_fade = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-fadeIn');
            observer_fade.unobserve(entry.target);
            entry.target.classList.remove('opacity-0')
        }
    });
}, observerOptions);

const observer_fade_floatLeft = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-fadeInFloatLeft');
            observer_fade.unobserve(entry.target);
            entry.target.classList.remove('opacity-0')
        }
    });
}, observerOptions);

const observer_fade_floatRight = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-fadeInFloatRight');
            observer_fade.unobserve(entry.target);
            entry.target.classList.remove('opacity-0')
        }
    });
}, observerOptions);

const observer_sway_left = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-swayLeft');
            observer_sway_left.unobserve(entry.target);
        }
    });
}, observerOptions);

const observer_sway_right = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-swayRight');
            observer_sway_right.unobserve(entry.target);
        }
    });
}, observerOptions);

window.addEventListener('DOMContentLoaded', (event) => { 

const items_fade = Array.from(document.getElementsByClassName('fade-in'));

for (let node of items_fade) {
    node.classList.add('opacity-0')
}

for (let item of items_fade) {
  observer_fade.observe(item);
}

const items_fade_floatLeft = Array.from(document.getElementsByClassName('fade-in-float-left'));

for (let node of items_fade_floatLeft) {
    node.classList.add('opacity-0')
}

for (let item of items_fade_floatLeft) {
  observer_fade_floatLeft.observe(item);
}

const items_fade_floatRight = Array.from(document.getElementsByClassName('fade-in-float-right'));

for (let node of items_fade_floatRight) {
    node.classList.add('opacity-0')
}

for (let item of items_fade_floatRight) {
  observer_fade_floatRight.observe(item);
}

const items_swayLeft = Array.from(document.getElementsByClassName('swayLeft'));

for (let item of items_swayLeft) {
  observer_sway_left.observe(item);
}

const items_swayRight = Array.from(document.getElementsByClassName('swayRight'));

for (let item of items_swayRight) {
  observer_sway_right.observe(item);
}

});